// 统一请求路径前缀在commmon/axios.js中修改
import {
  getRequest,
  postRequest,
  postRequestLogin,
  putRequest,
  putNoToken,
  getRequestWithNoToken,
} from "../assets/js/api";

//检查家长是否设置了隐私密码
export const _checkParentPasswordExist = (params) => {
  return getRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/checkParentPasswordExist",
    params
  );
};

//检查儿童是否设置了隐私密码
export const _checkStudentPasswordExist = (id, params) => {
  return getRequest(
    `/api-customer-c/psyPrivacyPasswordSetting/checkStudentPasswordExist/${id}`,
    params
  );
};

//设置/修改家长隐私密码
export const _setParentPassword = (params) => {
  return postRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/setParentPassword",
    params
  );
};

//设置/修改儿童隐私密码
export const _setStudentPassword = (params) => {
  return postRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/setStudentPassword",
    params
  );
};

//检查家长隐私密码是否正确
export const _checkParentPasswordEnable = (params) => {
  return postRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/checkParentPasswordEnable",
    params
  );
};
//检查儿童隐私密码是否正确
export const _checkStudentPasswordEnable = (params) => {
  return postRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/checkStudentPasswordEnable",
    params
  );
};
//查看家长隐私密码设置状态
export const _checkPrivacyEnable = (params) => {
  return getRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/checkPrivacyEnable/parent",
    params
  );
};
//设置家长隐私密码设置状态
export const _setPrivacyEnable = (params) => {
  return postRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/setPrivacyEnable/parent",
    params
  );
};
//查看儿童隐私密码设置状态
export const _checkStudentPrivacyEnable = (id, params) => {
  return getRequest(
    `/api-customer-c/psyPrivacyPasswordSetting/checkPrivacyEnable/student/${id}`,
    params
  );
};
//设置儿童隐私密码设置状态
export const _setStudentPrivacyEnable = (params) => {
  return postRequest(
    "/api-customer-c/psyPrivacyPasswordSetting/setPrivacyEnable/student",
    params
  );
};

// //【切换儿童】 查询儿童接口
// export const _getChildren = (params) => {
//     return getRequest('/api-customer-c/psy_student/switch/list', params)
// }

//【切换儿童】 查询儿童接口2
export const getHealthArchivesByLoginUser = (params) => {
  return postRequest(
    "/api-customer/psy_student/c/getHealthArchivesByLoginUser",
    params
  );
};

// 问卷分类
export const _category = (params) => {
  return postRequest("/api-customer/questionnaire/category", params);
};

// 课程考核
export const courseQuestionnaireList = (params) => {
  return postRequest("/api-content/course/courseQuestionnaireList", params);
};

// 查询分类下的量表
export const _projectByCategory = (params) => {
  return postRequest(
    "/api-customer/questionnaire/questionnaireByCategory",
    params
  );
};

// 成长记录
export const _psyRecords = (params) => {
  return postRequest("/api-customer/questionnaire/psyRecords", params);
};

// 查看问卷结果
export const _invertResult = (id, params) => {
  return getRequest(`/api-customer/questionnaire/invertResult/${id}`, params);
};

// 查询家长儿童正在进行中的问券数量
export const _paperNum = (params) => {
  return postRequest("/api-customer/questionnaire/underway", params);
};
// 查询家长儿童每个分类正在进行中的问卷数量
export const _projectProgress = (params) => {
  return postRequest("/api-customer/questionnaire/projectProgress", params);
};

// 查询家长儿童每个费雷正在进行的问券数量
// export const _underwayByCategory = (params) => {
//     return postRequest('/api-customer-c/questionnaire/underwayByCategory', params)
// }
